// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/rsc-crfi-report-content.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/rsc-crfi-report-content/rsc-crfi-report-content.js';

mount([g0]);
